import { combineReducers } from 'redux';
import { handleAction } from 'redux-actions';
import { converge, mergeRight } from 'ramda';

import { FETCH_DELTA_CONFIG_SUCCESS } from 'app/features/deltaConfig/actionTypes';
import { LANDING_PAGE } from 'app/features/deltaConfig/constants';
import { pickState, pathFromPayload } from 'app/reducers/helpers';

const initialState = { textKey: 'buttons_view_premium_plans' };

const heroBlock = handleAction(
  FETCH_DELTA_CONFIG_SUCCESS,
  converge(mergeRight, [
    pickState,
    pathFromPayload([LANDING_PAGE, 'heroBlock', 'button']),
  ]),
  initialState,
);

const devices = handleAction(
  FETCH_DELTA_CONFIG_SUCCESS,
  converge(mergeRight, [
    pickState,
    pathFromPayload([LANDING_PAGE, 'devices', 'button']),
  ]),
  initialState,
);

const viewPlansCta = combineReducers({ heroBlock, devices });

export { initialState, heroBlock, devices };

export default viewPlansCta;
